var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"qrcode",attrs:{"src":_vm.generate,"alt":"QR-Code","title":"QR-Code"}})
}
var staticRenderFns = []

export { render, staticRenderFns }